var _defs, _g, _g2, _g3, _g4, _path, _path2, _path3, _g5, _g6, _path4, _rect, _path5, _rect2, _rect3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g7, _rect4, _rect5, _rect6, _rect7, _path11, _path12, _path13, _g8, _path14, _g9, _path15, _path16, _path17, _g0, _path18, _g1, _path19, _path20, _path21, _path22, _g10, _path23, _g11, _path24, _path25, _path26, _path27, _g12, _path28, _g13, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g14, _path56, _g15, _g16, _g17, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g18, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _rect8, _rect9, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _g19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148.969,
    height: 73.729,
    viewBox: "0 0 148.969 73.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1.274,
    x2: 0.5,
    y2: -0.12,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6b8b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242626"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.895,
    r: 1.042,
    gradientTransform: "translate(0.221) scale(0.559 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#1e211d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#232521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#313330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#494a47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#595956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#686865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#91908f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#b3b2b1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.895,
    r: 1.042,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.895,
    r: 1.042,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.5,
    cy: 0.895,
    r: 1.041,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.5,
    cy: 0.895,
    r: 1.042,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.5,
    cy: 0.5,
    r: 0.318,
    gradientTransform: "matrix(1.573, 0, 0, -1.571, 2716.387, 1009.485)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#f4f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e7e5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#d4d0d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#c0bac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#c8c3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#e0dde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#f1f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#f4f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#e6e4e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#d3cfd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0bac4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8467",
    "data-name": "Group 8467",
    transform: "translate(-1.852 -0.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8466",
    "data-name": "Group 8466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8344",
    "data-name": "Group 8344"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8343",
    "data-name": "Group 8343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14000",
    "data-name": "Path 14000",
    d: "M148.935,55.668h-.608s-.433.291.038.705h.522Z",
    fill: "#727271"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8342",
    "data-name": "Group 8342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14001",
    "data-name": "Path 14001",
    d: "M149.9,54.393c.056,0,.114.006.167.009V57.63a.769.769,0,0,1-.167.014c-.723,0-1.109-.616-1.312-1.31v-.628A1.311,1.311,0,0,1,149.9,54.393Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14002",
    "data-name": "Path 14002",
    d: "M150.066,54.4s.755.238.755,1.616c0,1.521-.755,1.612-.755,1.612Z",
    fill: "#ed3a0f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14003",
    "data-name": "Path 14003",
    d: "M150.2,54.64a2.408,2.408,0,0,1,.473,1.783s-.087-.755-.473-1.006Z",
    fill: "#ffd4a8",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8465",
    "data-name": "Group 8465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8351",
    "data-name": "Group 8351"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8345",
    "data-name": "Group 8345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14004",
    "data-name": "Path 14004",
    d: "M48.316,46.684a52.458,52.458,0,0,1,.075,5.256h.793c.049-1.167.057-2.883-.079-5.294-.183-3.094-2.076-3.5-3.6-3.827-1.437-.307-2.476-.535-2.516-2.51a4.326,4.326,0,0,1,1.58-3.693c2.8-2.17,8.379-1.1,8.434-1.087l.168-.726c-.248-.05-6.014-1.157-9.1,1.243a5,5,0,0,0-1.867,4.28c.058,2.556,1.684,2.909,3.126,3.216C46.853,43.869,48.169,44.151,48.316,46.684Z",
    fill: "#020300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14005",
    "data-name": "Path 14005",
    d: "M47.789,34.815s-3.727.144-5.02,3.207A6.522,6.522,0,0,1,47.789,34.815Z",
    fill: "#bdbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14006",
    "data-name": "Path 14006",
    d: "M42.769,41.907s.038.887,2,1.34,3.333.766,3.57,2.411a2.1,2.1,0,0,0-1.441-2.038C45.312,42.958,43.316,43.17,42.769,41.907Z",
    fill: "#bdbcbc"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8346",
    "data-name": "Group 8346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14007",
    "data-name": "Path 14007",
    d: "M47.52,51.94h.815c.028-1.214,0-2.8-.1-4.847-.193-3.42-2.164-3.87-3.747-4.234-1.495-.339-2.572-.588-2.617-2.776A4.905,4.905,0,0,1,43.512,36c2.907-2.4,8.72-1.219,8.78-1.2l.166-.8c-.249-.06-6.249-1.28-9.467,1.372A5.672,5.672,0,0,0,41.046,40.1C41.1,42.929,42.8,43.32,44.3,43.662c1.584.36,2.953.673,3.107,3.48C47.52,49.166,47.539,50.744,47.52,51.94Z",
    fill: "#282928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14008",
    "data-name": "Path 14008",
    d: "M46.857,34s-3.877.164-5.223,3.55A6.826,6.826,0,0,1,46.857,34Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14009",
    "data-name": "Path 14009",
    d: "M41.634,41.857s.048.976,2.077,1.475,3.47.849,3.72,2.673a2.354,2.354,0,0,0-1.506-2.259C44.285,43.017,42.2,43.247,41.634,41.857Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8347",
    "data-name": "Group 8347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14010",
    "data-name": "Path 14010",
    d: "M54.9,32.05H51.243v4.877H56.05Z",
    fill: "#4f504f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14011",
    "data-name": "Path 14011",
    d: "M55.194,32.05H52.458v4.877H56.05Z",
    fill: "#282928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14012",
    "data-name": "Path 14012",
    d: "M58.861,30.887H53.417v7.252h7.149Z",
    fill: "#4f504f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14013",
    "data-name": "Path 14013",
    d: "M57.081,38.139h3.486l-1.706-7.252h-1.78Z",
    fill: "#282928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14014",
    "data-name": "Path 14014",
    d: "M54.9,31.9a.629.629,0,1,1-.627-.626A.63.63,0,0,1,54.9,31.9Z",
    fill: "#282928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14015",
    "data-name": "Path 14015",
    d: "M54.9,34.513a.629.629,0,1,1-.627-.632A.629.629,0,0,1,54.9,34.513Z",
    fill: "#282928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14016",
    "data-name": "Path 14016",
    d: "M54.9,36.927a.629.629,0,1,1-.627-.631A.627.627,0,0,1,54.9,36.927Z",
    fill: "#282928"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14017",
    "data-name": "Path 14017",
    d: "M53.426,23.886l-2,1.833,1.32,2.894,5.132,1.157V44.007h8.752V40.116l-2.162-2.262V28.243l3.224-8.016Z",
    fill: "#818080"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14018",
    "data-name": "Path 14018",
    d: "M65.542,25.572l2.152-5.345L53.426,23.886l-2,1.833.393.873A10.465,10.465,0,0,0,65.542,25.572Z",
    fill: "#818080",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5374",
    "data-name": "Rectangle 5374",
    width: 8.752,
    height: 3.134,
    transform: "translate(57.88 40.873)",
    fill: "#818080",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14019",
    "data-name": "Path 14019",
    d: "M82.869,51.94l-.578-10.527s-26.968.075-27.993,0-1.36,1.487-1.36,1.487l-1.686,9.04Z",
    fill: "#4f504f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14020",
    "data-name": "Path 14020",
    d: "M79.761,47.374l-.214-3.86s-22.143.062-22.985,0-1.112,1.222-1.112,1.222l-.5,2.638Z",
    fill: "#4f504f",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14021",
    "data-name": "Path 14021",
    d: "M80.012,51.94l-.2-3.467h-15.8V51.94Z",
    fill: "#4f504f",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14022",
    "data-name": "Path 14022",
    d: "M63.2,51.94V48.473H54.753L54.1,51.94Z",
    fill: "#4f504f",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14023",
    "data-name": "Path 14023",
    d: "M67.945,18A10.063,10.063,0,1,1,57.88,7.94,10.061,10.061,0,0,1,67.945,18Z",
    fill: "#969595"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14024",
    "data-name": "Path 14024",
    d: "M65.183,12.292A21.614,21.614,0,0,1,59.5,17.74a24.817,24.817,0,0,1-7.881,3.522,12.366,12.366,0,0,1-3.146.314,10.063,10.063,0,1,0,17.18-9.961C65.5,11.842,65.345,12.071,65.183,12.292Z",
    fill: "#969595",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14025",
    "data-name": "Path 14025",
    d: "M64.833,17.619a7.953,7.953,0,1,1-7.949-7.951A7.951,7.951,0,0,1,64.833,17.619Z",
    fill: "#969595",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8349",
    "data-name": "Group 8349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14026",
    "data-name": "Path 14026",
    d: "M58.639,28.032a.91.91,0,0,1-.922.9h0a.916.916,0,0,1-.926-.9V8.233a.916.916,0,0,1,.926-.906h0a.909.909,0,0,1,.922.906Z",
    fill: "#626362"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8348",
    "data-name": "Group 8348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14027",
    "data-name": "Path 14027",
    d: "M58.046,8.78a.327.327,0,1,1-.654,0,.327.327,0,0,1,.654,0Z",
    fill: "#969595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14028",
    "data-name": "Path 14028",
    d: "M58.046,12.308a.327.327,0,1,1-.329-.324A.33.33,0,0,1,58.046,12.308Z",
    fill: "#969595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14029",
    "data-name": "Path 14029",
    d: "M58.046,15.839a.327.327,0,1,1-.329-.325A.324.324,0,0,1,58.046,15.839Z",
    fill: "#969595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14030",
    "data-name": "Path 14030",
    d: "M58.046,19.366a.327.327,0,1,1-.329-.324A.326.326,0,0,1,58.046,19.366Z",
    fill: "#969595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14031",
    "data-name": "Path 14031",
    d: "M58.1,22.952a.384.384,0,0,1-.767,0,.384.384,0,0,1,.767,0Z",
    fill: "#969595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14032",
    "data-name": "Path 14032",
    d: "M58.1,26.592a.384.384,0,1,1-.767,0,.384.384,0,0,1,.767,0Z",
    fill: "#969595"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14033",
    "data-name": "Path 14033",
    d: "M59.351,45.414a1.135,1.135,0,1,1-1.132-1.136A1.135,1.135,0,0,1,59.351,45.414Z",
    fill: "#4f504f",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14034",
    "data-name": "Path 14034",
    d: "M62.271,49.786a.569.569,0,1,1-.568-.568A.566.566,0,0,1,62.271,49.786Z",
    fill: "#4f504f",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8350",
    "data-name": "Group 8350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14035",
    "data-name": "Path 14035",
    d: "M65.893,49.493a.3.3,0,0,1-.3.293.293.293,0,0,1,0-.586A.3.3,0,0,1,65.893,49.493Z",
    fill: "#4f504f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14036",
    "data-name": "Path 14036",
    d: "M68.136,49.531a.259.259,0,0,1-.517,0,.259.259,0,1,1,.517,0Z",
    fill: "#4f504f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14037",
    "data-name": "Path 14037",
    d: "M70.451,49.493a.289.289,0,0,1-.292.293.293.293,0,0,1,0-.586A.291.291,0,0,1,70.451,49.493Z",
    fill: "#4f504f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14038",
    "data-name": "Path 14038",
    d: "M72.7,49.531a.255.255,0,0,1-.26.255.252.252,0,0,1-.252-.255.256.256,0,0,1,.252-.262A.259.259,0,0,1,72.7,49.531Z",
    fill: "#4f504f"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14039",
    "data-name": "Path 14039",
    d: "M64.018,40.3H58.824V29.851l4.052-1.165V38.931Z",
    fill: "#4f504f",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14040",
    "data-name": "Path 14040",
    d: "M52.064,50.356l1.3-6.848A2.053,2.053,0,0,1,55.4,41.857H69.1l-13.7.592a1.787,1.787,0,0,0-1.518,1.481Z",
    fill: "#818080",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14041",
    "data-name": "Path 14041",
    d: "M68.388,42.665a22.01,22.01,0,0,0,5.795,9.275h8.686l-.578-10.527s-7.172.018-14.259.03C68.146,41.851,68.262,42.261,68.388,42.665Z",
    fill: "#4f504f",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5375",
    "data-name": "Rectangle 5375",
    width: 5.556,
    height: 4.873,
    transform: "translate(37.791 53.498)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14042",
    "data-name": "Path 14042",
    d: "M106.243,64.152h29.267V55.207h-29.2Z",
    fill: "#121212"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8358",
    "data-name": "Group 8358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8353",
    "data-name": "Group 8353"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5376",
    "data-name": "Rectangle 5376",
    width: 106.89,
    height: 7.724,
    transform: "translate(41.501 51.957)",
    fill: "#292929"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5377",
    "data-name": "Rectangle 5377",
    width: 106.89,
    height: 2.838,
    transform: "translate(41.501 51.957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8352",
    "data-name": "Group 8352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14043",
    "data-name": "Path 14043",
    d: "M88.535,51.957c-.261,1.4-.608,3.141-.811,3.846-.376,1.263-.667,1.384-2,1.384H82.7l.007,2.475h4.033c1.11,0,2.131.019,2.711-1.724.384-1.174,1.288-4.149,1.845-5.981Z",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14044",
    "data-name": "Path 14044",
    d: "M88.841,51.957c-.27,1.41-.695,3.539-.923,4.28-.359,1.154-.635,1.264-1.888,1.264H83.181l-.2,1.723h3.808c1.044,0,1.914.03,2.464-1.559.385-1.122,1.24-4.08,1.713-5.708Z",
    fill: "#525252"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14045",
    "data-name": "Path 14045",
    d: "M63.976,51.957l2.446,9.2.733.735H81.971l.821-.917.975-9.019Z",
    fill: "#818080"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14046",
    "data-name": "Path 14046",
    d: "M63.976,51.957l.627,2.362H83.51l.258-2.362Z",
    fill: "#818080",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14047",
    "data-name": "Path 14047",
    d: "M67.18,53.5a1.284,1.284,0,1,1-1.287-1.281A1.285,1.285,0,0,1,67.18,53.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14048",
    "data-name": "Path 14048",
    d: "M69.839,53.47a1.287,1.287,0,1,1-1.287-1.281A1.285,1.285,0,0,1,69.839,53.47Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14049",
    "data-name": "Path 14049",
    d: "M69.621,53.459a1.071,1.071,0,1,1-1.069-1.067A1.073,1.073,0,0,1,69.621,53.459Z",
    fill: "#427724"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14050",
    "data-name": "Path 14050",
    d: "M66.959,53.479a1.068,1.068,0,1,1-1.066-1.069A1.064,1.064,0,0,1,66.959,53.479Z",
    fill: "#be3324"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14051",
    "data-name": "Path 14051",
    d: "M65.406,55.68l1.247,5.273.646.8H81.513l1.067-.826.936-8.784L82.18,60.395l-1.244,1.111H67.766l-.824-.755Z",
    fill: "#4b4b4b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8357",
    "data-name": "Group 8357"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8354",
    "data-name": "Group 8354"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5378",
    "data-name": "Rectangle 5378",
    width: 0.872,
    height: 11.552,
    transform: "translate(67.066 51.957)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5379",
    "data-name": "Rectangle 5379",
    width: 0.871,
    height: 11.552,
    transform: "translate(91.211 51.957)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8355",
    "data-name": "Group 8355"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5380",
    "data-name": "Rectangle 5380",
    width: 30.784,
    height: 1.958,
    transform: "translate(64.184 57.562)",
    fill: "#e3e3e3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5381",
    "data-name": "Rectangle 5381",
    width: 30.784,
    height: 0.977,
    transform: "translate(64.184 58.544)",
    fill: "#8f8f8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14052",
    "data-name": "Path 14052",
    d: "M64.65,57.562h-.466v1.959h2.238C65.838,58.863,65.257,58.205,64.65,57.562Z",
    fill: "#3d3d3d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14053",
    "data-name": "Path 14053",
    d: "M74.887,57.562H69.722c.589.676,1.2,1.326,1.827,1.959h5.415C76.265,58.877,75.571,58.227,74.887,57.562Z",
    fill: "#3d3d3d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14054",
    "data-name": "Path 14054",
    d: "M93.29,58.512c.375.332.75.674,1.12,1.009h.559V57.562h-2.73C92.587,57.881,92.943,58.2,93.29,58.512Z",
    fill: "#3d3d3d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14055",
    "data-name": "Path 14055",
    d: "M86.359,57.562H80.9c.736.659,1.473,1.311,2.224,1.959h5.51C87.9,58.844,87.147,58.189,86.359,57.562Z",
    fill: "#3d3d3d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8356",
    "data-name": "Group 8356"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5382",
    "data-name": "Rectangle 5382",
    width: 30.784,
    height: 1.954,
    transform: "translate(64.184 62.046)",
    fill: "#e3e3e3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5383",
    "data-name": "Rectangle 5383",
    width: 30.784,
    height: 0.979,
    transform: "translate(64.184 63.021)",
    fill: "#8f8f8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14056",
    "data-name": "Path 14056",
    d: "M64.65,62.046h-.466V64h2.238C65.838,63.34,65.257,62.68,64.65,62.046Z",
    fill: "#3d3d3d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14057",
    "data-name": "Path 14057",
    d: "M74.887,62.046H69.722c.589.67,1.2,1.318,1.827,1.954h5.415Q75.916,63.034,74.887,62.046Z",
    fill: "#3d3d3d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14058",
    "data-name": "Path 14058",
    d: "M93.29,62.987c.375.334.75.674,1.12,1.013h.559V62.046h-2.73C92.587,62.363,92.943,62.676,93.29,62.987Z",
    fill: "#3d3d3d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14059",
    "data-name": "Path 14059",
    d: "M86.359,62.046H80.9c.736.655,1.473,1.31,2.224,1.954h5.51C87.9,63.321,87.147,62.667,86.359,62.046Z",
    fill: "#3d3d3d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8374",
    "data-name": "Group 8374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8373",
    "data-name": "Group 8373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8372",
    "data-name": "Group 8372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8364",
    "data-name": "Group 8364"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14060",
    "data-name": "Path 14060",
    d: "M145.237,63.982a10.016,10.016,0,1,1-10.013-10.015A10.017,10.017,0,0,1,145.237,63.982Z",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8359",
    "data-name": "Group 8359",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14061",
    "data-name": "Path 14061",
    d: "M135.289,55.115a9.715,9.715,0,0,1,9.642,8.561,9.709,9.709,0,0,0-19.416.177,10.106,10.106,0,0,0,.071,1.138c0-.057,0-.114,0-.166A9.706,9.706,0,0,1,135.289,55.115Z",
    opacity: 0.5,
    fill: "url(#radial-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8360",
    "data-name": "Group 8360",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14062",
    "data-name": "Path 14062",
    d: "M135.289,72.793a9.71,9.71,0,0,0,9.642-8.562,9.709,9.709,0,0,1-19.416-.168,10.046,10.046,0,0,1,.071-1.142c0,.053,0,.118,0,.164A9.706,9.706,0,0,0,135.289,72.793Z",
    fill: "#1d1d1b",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14063",
    "data-name": "Path 14063",
    d: "M135.224,56.44A7.557,7.557,0,1,0,142.78,64,7.555,7.555,0,0,0,135.224,56.44Z",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14064",
    "data-name": "Path 14064",
    d: "M141.538,63.961a6.4,6.4,0,1,1-6.4-6.4A6.406,6.406,0,0,1,141.538,63.961Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14065",
    "data-name": "Path 14065",
    d: "M140.73,63.961a5.59,5.59,0,1,1-5.591-5.59A5.586,5.586,0,0,1,140.73,63.961Z",
    fill: "#2c2d2b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14066",
    "data-name": "Path 14066",
    d: "M140.308,63.961a5.174,5.174,0,1,1-5.169-5.171A5.17,5.17,0,0,1,140.308,63.961Z",
    fill: "#686867"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8361",
    "data-name": "Group 8361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14067",
    "data-name": "Path 14067",
    d: "M136.981,63.937a1.756,1.756,0,1,1-1.757-1.762A1.754,1.754,0,0,1,136.981,63.937Z",
    fill: "#2d2e2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8362",
    "data-name": "Group 8362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14068",
    "data-name": "Path 14068",
    d: "M136.217,63.937a.992.992,0,1,1-.993-.992A.994.994,0,0,1,136.217,63.937Z",
    fill: "#2d2e2d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8363",
    "data-name": "Group 8363",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14069",
    "data-name": "Path 14069",
    d: "M128.873,63.494c-.007.085-.007.159-.007.236a6.273,6.273,0,1,0,12.547,0c0-.088-.008-.162-.008-.242A20.226,20.226,0,0,1,128.873,63.494Z",
    fill: "#bbbaba"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8371",
    "data-name": "Group 8371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8367",
    "data-name": "Group 8367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8365",
    "data-name": "Group 8365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14070",
    "data-name": "Path 14070",
    d: "M135.224,59.581a.283.283,0,0,1-.283-.283.284.284,0,1,1,.283.283Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14071",
    "data-name": "Path 14071",
    d: "M135.224,68.729a.284.284,0,1,1,.285-.285A.284.284,0,0,1,135.224,68.729Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8366",
    "data-name": "Group 8366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14072",
    "data-name": "Path 14072",
    d: "M139.514,63.87a.285.285,0,1,1,.57,0,.285.285,0,0,1-.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14073",
    "data-name": "Path 14073",
    d: "M130.368,63.87a.284.284,0,0,1,.282-.285.284.284,0,1,1,0,.567A.282.282,0,0,1,130.368,63.87Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8370",
    "data-name": "Group 8370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8368",
    "data-name": "Group 8368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14074",
    "data-name": "Path 14074",
    d: "M138.263,60.836a.275.275,0,0,1,0-.4.281.281,0,0,1,.4.4A.277.277,0,0,1,138.263,60.836Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14075",
    "data-name": "Path 14075",
    d: "M131.793,67.3a.278.278,0,0,1,0-.4.286.286,0,0,1,.394,0,.28.28,0,0,1-.394.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8369",
    "data-name": "Group 8369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14076",
    "data-name": "Path 14076",
    d: "M138.263,66.9a.288.288,0,0,1,.4,0,.281.281,0,0,1,0,.4.281.281,0,0,1-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14077",
    "data-name": "Path 14077",
    d: "M131.793,60.436a.278.278,0,0,1,.394,0,.275.275,0,0,1,0,.4.281.281,0,0,1-.394-.4Z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8390",
    "data-name": "Group 8390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8389",
    "data-name": "Group 8389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8388",
    "data-name": "Group 8388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8380",
    "data-name": "Group 8380"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14078",
    "data-name": "Path 14078",
    d: "M116.258,63.982a10.015,10.015,0,1,1-10.015-10.015A10.021,10.021,0,0,1,116.258,63.982Z",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8375",
    "data-name": "Group 8375",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14079",
    "data-name": "Path 14079",
    d: "M106.307,55.115a9.718,9.718,0,0,1,9.645,8.561,9.709,9.709,0,0,0-19.417.177,9.051,9.051,0,0,0,.068,1.138c0-.057,0-.114,0-.166A9.705,9.705,0,0,1,106.307,55.115Z",
    opacity: 0.5,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8376",
    "data-name": "Group 8376",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14080",
    "data-name": "Path 14080",
    d: "M106.307,72.793a9.713,9.713,0,0,0,9.645-8.562,9.709,9.709,0,0,1-19.417-.168,9.014,9.014,0,0,1,.068-1.142c0,.053,0,.118,0,.164A9.706,9.706,0,0,0,106.307,72.793Z",
    fill: "#1d1d1b",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14081",
    "data-name": "Path 14081",
    d: "M106.243,56.44A7.557,7.557,0,1,0,113.8,64,7.559,7.559,0,0,0,106.243,56.44Z",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14082",
    "data-name": "Path 14082",
    d: "M112.56,63.961a6.4,6.4,0,1,1-6.4-6.4A6.407,6.407,0,0,1,112.56,63.961Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14083",
    "data-name": "Path 14083",
    d: "M111.741,63.961a5.588,5.588,0,1,1-5.584-5.59A5.578,5.578,0,0,1,111.741,63.961Z",
    fill: "#2c2d2b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14084",
    "data-name": "Path 14084",
    d: "M111.327,63.961a5.172,5.172,0,1,1-5.17-5.171A5.17,5.17,0,0,1,111.327,63.961Z",
    fill: "#686867"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8377",
    "data-name": "Group 8377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14085",
    "data-name": "Path 14085",
    d: "M108,63.937a1.763,1.763,0,1,1-1.762-1.762A1.759,1.759,0,0,1,108,63.937Z",
    fill: "#2d2e2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8378",
    "data-name": "Group 8378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14086",
    "data-name": "Path 14086",
    d: "M107.237,63.937a.993.993,0,1,1-.994-.992A.993.993,0,0,1,107.237,63.937Z",
    fill: "#2d2e2d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8379",
    "data-name": "Group 8379",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14087",
    "data-name": "Path 14087",
    d: "M99.888,63.494v.236a6.27,6.27,0,1,0,12.539,0c0-.088-.006-.162-.006-.242A20.229,20.229,0,0,1,99.888,63.494Z",
    fill: "#bbbaba"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8387",
    "data-name": "Group 8387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8383",
    "data-name": "Group 8383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8381",
    "data-name": "Group 8381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14088",
    "data-name": "Path 14088",
    d: "M106.243,59.581a.284.284,0,0,1-.281-.283.282.282,0,1,1,.281.283Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14089",
    "data-name": "Path 14089",
    d: "M106.243,68.729a.284.284,0,1,1,.283-.285A.285.285,0,0,1,106.243,68.729Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8382",
    "data-name": "Group 8382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14090",
    "data-name": "Path 14090",
    d: "M110.535,63.87a.283.283,0,1,1,.566,0,.283.283,0,0,1-.566,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14091",
    "data-name": "Path 14091",
    d: "M101.391,63.87a.281.281,0,1,1,.28.282A.284.284,0,0,1,101.391,63.87Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8386",
    "data-name": "Group 8386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8384",
    "data-name": "Group 8384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14092",
    "data-name": "Path 14092",
    d: "M109.277,60.836a.285.285,0,1,1,.406,0A.291.291,0,0,1,109.277,60.836Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14093",
    "data-name": "Path 14093",
    d: "M102.807,67.3a.283.283,0,0,1,0-.4.3.3,0,0,1,.4,0,.282.282,0,1,1-.4.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8385",
    "data-name": "Group 8385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14094",
    "data-name": "Path 14094",
    d: "M109.277,66.9a.3.3,0,0,1,.406,0,.289.289,0,0,1,0,.4.285.285,0,0,1-.406,0A.289.289,0,0,1,109.277,66.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14095",
    "data-name": "Path 14095",
    d: "M102.807,60.436a.287.287,0,0,1,.4,0,.28.28,0,0,1,0,.4.283.283,0,0,1-.4-.4Z"
  })))))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14096",
    "data-name": "Path 14096",
    d: "M95.542,57.375l4.347-4.993h44.348l5.246,9.137h-2.25L142.78,53.8h-41.8l-4,4.568Z",
    fill: "#818080"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14097",
    "data-name": "Path 14097",
    d: "M95.542,57.375l4.347-4.993h44.348l5.246,9.137h-1.091l-4.792-8.29-43.034-.141-4.371,4.5Z",
    fill: "#818080",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8404",
    "data-name": "Group 8404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8396",
    "data-name": "Group 8396"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14098",
    "data-name": "Path 14098",
    d: "M63.377,63.982A10.015,10.015,0,1,1,53.361,53.967,10.018,10.018,0,0,1,63.377,63.982Z",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8391",
    "data-name": "Group 8391",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14099",
    "data-name": "Path 14099",
    d: "M53.426,55.115a9.708,9.708,0,0,1,9.641,8.561,9.706,9.706,0,0,0-19.411.177,9.049,9.049,0,0,0,.067,1.138c0-.057,0-.114,0-.166A9.7,9.7,0,0,1,53.426,55.115Z",
    opacity: 0.5,
    fill: "url(#radial-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8392",
    "data-name": "Group 8392",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14100",
    "data-name": "Path 14100",
    d: "M53.426,72.793a9.7,9.7,0,0,0,9.641-8.562,9.706,9.706,0,0,1-19.411-.168,9.013,9.013,0,0,1,.067-1.142c0,.053,0,.118,0,.164A9.7,9.7,0,0,0,53.426,72.793Z",
    fill: "#1d1d1b",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14101",
    "data-name": "Path 14101",
    d: "M53.361,56.44A7.557,7.557,0,1,0,60.922,64,7.558,7.558,0,0,0,53.361,56.44Z",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14102",
    "data-name": "Path 14102",
    d: "M59.683,63.961a6.4,6.4,0,1,1-6.407-6.4A6.41,6.41,0,0,1,59.683,63.961Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14103",
    "data-name": "Path 14103",
    d: "M58.861,63.961a5.586,5.586,0,1,1-5.585-5.59A5.58,5.58,0,0,1,58.861,63.961Z",
    fill: "#2c2d2b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14104",
    "data-name": "Path 14104",
    d: "M58.447,63.961a5.17,5.17,0,1,1-5.171-5.171A5.171,5.171,0,0,1,58.447,63.961Z",
    fill: "#686867"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8393",
    "data-name": "Group 8393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14105",
    "data-name": "Path 14105",
    d: "M55.126,63.937a1.76,1.76,0,1,1-1.765-1.762A1.76,1.76,0,0,1,55.126,63.937Z",
    fill: "#2d2e2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8394",
    "data-name": "Group 8394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14106",
    "data-name": "Path 14106",
    d: "M54.355,63.937a.991.991,0,1,1-.994-.992A.992.992,0,0,1,54.355,63.937Z",
    fill: "#2d2e2d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8395",
    "data-name": "Group 8395",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14107",
    "data-name": "Path 14107",
    d: "M47.007,63.494v.236a6.27,6.27,0,1,0,12.539,0v-.242A20.246,20.246,0,0,1,47.007,63.494Z",
    fill: "#bbbaba"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8403",
    "data-name": "Group 8403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8399",
    "data-name": "Group 8399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8397",
    "data-name": "Group 8397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14108",
    "data-name": "Path 14108",
    d: "M53.361,59.581a.279.279,0,0,1-.274-.283.275.275,0,0,1,.274-.284.286.286,0,0,1,.287.284A.289.289,0,0,1,53.361,59.581Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14109",
    "data-name": "Path 14109",
    d: "M53.361,68.729a.284.284,0,0,1,0-.568.284.284,0,1,1,0,.568Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8398",
    "data-name": "Group 8398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14110",
    "data-name": "Path 14110",
    d: "M57.66,63.87a.282.282,0,1,1,.28.282A.286.286,0,0,1,57.66,63.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14111",
    "data-name": "Path 14111",
    d: "M48.509,63.87a.285.285,0,0,1,.281-.285.284.284,0,1,1,0,.567A.283.283,0,0,1,48.509,63.87Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8402",
    "data-name": "Group 8402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8400",
    "data-name": "Group 8400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14112",
    "data-name": "Path 14112",
    d: "M56.4,60.836a.291.291,0,0,1,0-.4.284.284,0,0,1,.4.4A.284.284,0,0,1,56.4,60.836Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14113",
    "data-name": "Path 14113",
    d: "M49.932,67.3a.281.281,0,0,1,0-.4.288.288,0,0,1,.4,0,.278.278,0,0,1,0,.4A.274.274,0,0,1,49.932,67.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8401",
    "data-name": "Group 8401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14114",
    "data-name": "Path 14114",
    d: "M56.4,66.9a.3.3,0,0,1,.4,0,.283.283,0,0,1-.4.4A.289.289,0,0,1,56.4,66.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14115",
    "data-name": "Path 14115",
    d: "M49.932,60.436a.281.281,0,1,1,0,.4A.284.284,0,0,1,49.932,60.436Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8452",
    "data-name": "Group 8452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8405",
    "data-name": "Group 8405"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14116",
    "data-name": "Path 14116",
    d: "M39.054,59.681H37.408V9.029A5.39,5.39,0,0,1,38.975,4.9a5.717,5.717,0,0,1,3.94-1.351h4.262v1.64H42.83a4.105,4.105,0,0,0-2.748.924,3.851,3.851,0,0,0-1.028,2.917Z",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14117",
    "data-name": "Path 14117",
    d: "M46.268,3.884H42.844s-4.294.033-5.11,4.056v5.937l.471-5.752s.395-3.176,4.68-3.881Z",
    fill: "#a8a8a8",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8421",
    "data-name": "Group 8421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8420",
    "data-name": "Group 8420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8419",
    "data-name": "Group 8419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8411",
    "data-name": "Group 8411"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14118",
    "data-name": "Path 14118",
    d: "M41.616,63.865A10.013,10.013,0,1,1,31.609,53.849,10.015,10.015,0,0,1,41.616,63.865Z",
    fill: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8406",
    "data-name": "Group 8406",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14119",
    "data-name": "Path 14119",
    d: "M31.668,55a9.708,9.708,0,0,1,9.639,8.567,9.705,9.705,0,0,0-19.409.17,10.681,10.681,0,0,0,.065,1.139c0-.058,0-.117,0-.17A9.708,9.708,0,0,1,31.668,55Z",
    opacity: 0.5,
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8407",
    "data-name": "Group 8407",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14120",
    "data-name": "Path 14120",
    d: "M31.668,72.676a9.7,9.7,0,0,0,9.639-8.562A9.705,9.705,0,0,1,21.9,63.95a10.6,10.6,0,0,1,.065-1.146c0,.057,0,.117,0,.167A9.706,9.706,0,0,0,31.668,72.676Z",
    fill: "#1d1d1b",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14121",
    "data-name": "Path 14121",
    d: "M31.609,56.326a7.556,7.556,0,1,0,7.549,7.559A7.554,7.554,0,0,0,31.609,56.326Z",
    fill: "#2e2d2c",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14122",
    "data-name": "Path 14122",
    d: "M37.923,63.847a6.4,6.4,0,1,1-6.4-6.4A6.406,6.406,0,0,1,37.923,63.847Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14123",
    "data-name": "Path 14123",
    d: "M37.109,63.847a5.591,5.591,0,1,1-5.586-5.592A5.588,5.588,0,0,1,37.109,63.847Z",
    fill: "#2c2d2b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14124",
    "data-name": "Path 14124",
    d: "M36.692,63.847a5.175,5.175,0,1,1-5.169-5.171A5.173,5.173,0,0,1,36.692,63.847Z",
    fill: "#686867"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8408",
    "data-name": "Group 8408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14125",
    "data-name": "Path 14125",
    d: "M33.368,63.822a1.761,1.761,0,1,1-1.759-1.762A1.755,1.755,0,0,1,33.368,63.822Z",
    fill: "#2d2e2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8409",
    "data-name": "Group 8409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14126",
    "data-name": "Path 14126",
    d: "M32.6,63.822a.99.99,0,1,1-.988-.992A1,1,0,0,1,32.6,63.822Z",
    fill: "#2d2e2d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8410",
    "data-name": "Group 8410",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14127",
    "data-name": "Path 14127",
    d: "M25.254,63.38a1.6,1.6,0,0,0-.012.235,6.275,6.275,0,1,0,12.549,0c0-.083-.01-.156-.01-.241A20.232,20.232,0,0,1,25.254,63.38Z",
    fill: "#bbbaba"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8418",
    "data-name": "Group 8418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8414",
    "data-name": "Group 8414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8412",
    "data-name": "Group 8412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14128",
    "data-name": "Path 14128",
    d: "M31.609,59.466a.285.285,0,1,1,0-.57.285.285,0,0,1,0,.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14129",
    "data-name": "Path 14129",
    d: "M31.609,68.612a.282.282,0,1,1,.28-.282A.282.282,0,0,1,31.609,68.612Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8413",
    "data-name": "Group 8413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14130",
    "data-name": "Path 14130",
    d: "M35.9,63.754a.282.282,0,1,1,.564,0,.282.282,0,1,1-.564,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14131",
    "data-name": "Path 14131",
    d: "M26.745,63.754a.285.285,0,0,1,.57,0,.285.285,0,0,1-.57,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8417",
    "data-name": "Group 8417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8415",
    "data-name": "Group 8415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14132",
    "data-name": "Path 14132",
    d: "M34.644,60.722a.271.271,0,0,1,0-.4.278.278,0,0,1,.4,0,.282.282,0,0,1-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14133",
    "data-name": "Path 14133",
    d: "M28.169,67.193a.285.285,0,0,1,.4-.4.285.285,0,0,1-.4.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8416",
    "data-name": "Group 8416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14134",
    "data-name": "Path 14134",
    d: "M34.644,66.789a.289.289,0,0,1,.4,0,.292.292,0,0,1,0,.4.287.287,0,0,1-.4,0A.276.276,0,0,1,34.644,66.789Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14135",
    "data-name": "Path 14135",
    d: "M28.169,60.323a.284.284,0,1,1,.4.4.291.291,0,0,1-.4,0A.288.288,0,0,1,28.169,60.323Z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8424",
    "data-name": "Group 8424"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14136",
    "data-name": "Path 14136",
    d: "M10.307,45.858l4.015,4.322H9.739Z",
    fill: "#0f0f0f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14137",
    "data-name": "Path 14137",
    d: "M15.1,30.887l-.552,2.629.276.4.607-2.594Z",
    fill: "#2b2b2b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14138",
    "data-name": "Path 14138",
    d: "M18.359,35.214l-2.666-.335-.292-.391,2.65.27Z",
    fill: "#2b2b2b"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14139",
    "data-name": "Path 14139",
    d: "M9.479,49.269H32.432v3.352H11.287Z",
    fill: "#23211f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14140",
    "data-name": "Path 14140",
    d: "M9.479,50.9H32.432v1.725H11.287Z",
    fill: "#696969",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14141",
    "data-name": "Path 14141",
    d: "M11.636,35.688l4.377-3.264,1,1.245-3.861,3.94Z",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14142",
    "data-name": "Path 14142",
    d: "M12.56,36.866l.588.743,3.861-3.94-.551-.687C15.693,33.733,13.1,36.319,12.56,36.866Z",
    fill: "#525252",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14143",
    "data-name": "Path 14143",
    d: "M16.689,34l.32-.329-1-1.245-.265.2C16.052,33.085,16.362,33.546,16.689,34Z",
    fill: "#525252",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14144",
    "data-name": "Path 14144",
    d: "M13.476,34.322l-1.84,1.366,1.512,1.921,1.644-1.676C14.342,35.409,13.9,34.865,13.476,34.322Z",
    fill: "#525252",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14145",
    "data-name": "Path 14145",
    d: "M11.155,33.791l1.037-.549,2.908,3.7-.679,1.194Z",
    fill: "#0f0f0f"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14146",
    "data-name": "Path 14146",
    d: "M18.858,34.48c.377.506.464,1.072.191,1.271h0c-.265.2-.786-.049-1.162-.549L14.9,31.185c-.372-.5-.458-1.072-.195-1.27h0c.264-.2.792.047,1.159.549Z",
    fill: "#0f0f0f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14147",
    "data-name": "Path 14147",
    d: "M7.668,36.115l.666-3.072,2.946.2,3.409,4.408s.287.253,0,.957-4.568,12.039-4.568,12.039L5.8,48.317Z",
    fill: "#914a17"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14148",
    "data-name": "Path 14148",
    d: "M7.668,36.115l.666-3.072,1.973.132L7.349,46.452s3.578,2.053,3.471,2.343c-.272.712-.7,1.851-.7,1.851L5.8,48.317Z",
    fill: "#914a17",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14149",
    "data-name": "Path 14149",
    d: "M35,41.634s-9.834.752-14,1.436a2.435,2.435,0,0,0-1.743,2.113c-.375,1.868-.935,8.156-.935,8.156H29.964Z",
    fill: "#363432"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14150",
    "data-name": "Path 14150",
    d: "M32.587,47.236,35,41.634s-9.834.752-14,1.436a2.435,2.435,0,0,0-1.743,2.113c-.1.466-.206,1.21-.308,2.053Z",
    fill: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14151",
    "data-name": "Path 14151",
    d: "M30.869,42.631s-5.7.413-9.332,1.012a2.133,2.133,0,0,0-1.518,1.845c-.322,1.622-.72,6.12-.72,6.12h7.75l.833-6.319,2.9-2.05Z",
    fill: "#696969",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8422",
    "data-name": "Group 8422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14152",
    "data-name": "Path 14152",
    d: "M21.7,44.013c3.2-.522,8.019-.915,9.109-1l.058-.386s-5.7.413-9.332,1.012a2.133,2.133,0,0,0-1.518,1.845c-.322,1.622-.72,6.12-.72,6.12h.2c.1-1.105.42-4.413.691-5.755A2.135,2.135,0,0,1,21.7,44.013Z",
    fill: "#696969",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14153",
    "data-name": "Path 14153",
    d: "M13.37,34.518l2.465-1.878.107.134L13.63,34.85Z",
    fill: "#525252",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8423",
    "data-name": "Group 8423"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14154",
    "data-name": "Path 14154",
    d: "M21.618,40.429s-3.173.215-3.3,1.416,1.09,1.384,2.38,1.319L30.627,42a1.166,1.166,0,0,0,.909-.782c.247-.7,1.451-7.193,1.788-10.414,0,0,.082-1.825-1.04-1.869a2.662,2.662,0,0,0-2.615,1.951c-.412,1.285-1.2,8.012.084,9.507,0,0-.684-.523-3.278-.376C24.609,40.121,21.618,40.429,21.618,40.429Z",
    fill: "#303030"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14155",
    "data-name": "Path 14155",
    d: "M32.284,28.936a2.556,2.556,0,0,0-1.34.329.849.849,0,0,1,.1-.009c.551-.02,1.272.327,1.257.961a4.722,4.722,0,0,1-.323,1.287,11.4,11.4,0,0,0-.47,1.81,28.6,28.6,0,0,0-.289,3.906c-.015.612.035,1.381-.482,1.814a1.063,1.063,0,0,1-1.348-.263,2.06,2.06,0,0,1-.26-.44,4.024,4.024,0,0,0,.627,2.063,3.452,3.452,0,0,0-1.65-.376c-.265.5-.382,1.081-.961,1.346a9.95,9.95,0,0,1-2.456.464c-1.157.182-2.317.341-3.476.486-.915.116-1.839.169-2.765.236.35.57,1.28.663,2.255.614L30.627,42a1.166,1.166,0,0,0,.909-.782c.247-.7,1.451-7.193,1.788-10.414C33.324,30.805,33.406,28.98,32.284,28.936Z",
    fill: "#0f0f0f"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14156",
    "data-name": "Path 14156",
    d: "M32.432,41.845s-1.264-2.28-3.094-2.327S28.3,42.274,28.3,42.274Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14157",
    "data-name": "Path 14157",
    d: "M31.2,29.386s-.945.085-1.461,2.136-.628,6.4-.345,6.943C29.4,38.465,29.559,31.485,31.2,29.386Z",
    fill: "#303030",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14158",
    "data-name": "Path 14158",
    d: "M30.343,41a.55.55,0,1,1-.55-.547A.546.546,0,0,1,30.343,41Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14159",
    "data-name": "Path 14159",
    d: "M30.086,41a.3.3,0,0,1-.293.3.3.3,0,1,1,0-.6A.294.294,0,0,1,30.086,41Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14160",
    "data-name": "Path 14160",
    d: "M18.445,42.112s-.182-1.165,3.014-1.565c0,0,5.249-.511,5.781-.432,0,0-5.95.534-7.085.888A3.616,3.616,0,0,0,18.445,42.112Z",
    fill: "#303030",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14161",
    "data-name": "Path 14161",
    d: "M38.825,52.069l-17.2.033L18.68,64.152H38.825Z",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8425",
    "data-name": "Group 8425"
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14162",
    "data-name": "Path 14162",
    d: "M14.085,15.017s-2.582.172-3.158,2.456L5.956,39.6a5.342,5.342,0,0,1-2.209,2.333,3.33,3.33,0,0,0-1.142,2.727v18.9H18.68l3.091-12.023H38.205V15.017ZM24.38,38.349H8.868a5.107,5.107,0,0,1-.5-.258,2.45,2.45,0,0,1-1.012-1.948C8.643,31.926,11.823,19,11.823,19a3.707,3.707,0,0,1,3.468-2.509c1.354-.057,5.594-.057,9.089-.043Zm11.331,0H25.936V16.454c3.04.011,5.549.035,5.549.035s4-.115,4.226,3.862Z",
    fill: "#4A4A4A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14163",
    "data-name": "Path 14163",
    d: "M15.291,16.489A3.707,3.707,0,0,0,11.823,19S8.643,31.926,7.359,36.143a2.45,2.45,0,0,0,1.012,1.948,5.107,5.107,0,0,0,.5.258H24.38v-21.9C20.885,16.432,16.645,16.432,15.291,16.489Z",
    fill: "#00a8e3",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14164",
    "data-name": "Path 14164",
    d: "M9.959,26.442c-.287,1.128-.586,2.294-.885,3.423,3.324-2,13.527-8.113,15.306-9.172v-2.87C19.547,20.654,14.814,23.664,9.959,26.442Z",
    fill: "#9be9e3",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14165",
    "data-name": "Path 14165",
    d: "M24.38,35.875V33.138q-4.584,2.591-9.143,5.211h5.375C21.868,37.531,23.125,36.7,24.38,35.875Z",
    fill: "#9be9e3",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14166",
    "data-name": "Path 14166",
    d: "M31.485,16.489s-2.509-.024-5.549-.035V38.349h9.775v-18C35.489,16.374,31.485,16.489,31.485,16.489Z",
    fill: "#00a8e3",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14167",
    "data-name": "Path 14167",
    d: "M35.711,28.957V26.712q-4.882,2.774-9.775,5.541v2.6C27.845,33.609,34.383,29.711,35.711,28.957Z",
    fill: "#9be9e3",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14168",
    "data-name": "Path 14168",
    d: "M25.936,16.924V19.76q2.731-1.632,5.462-3.271c-.4,0-2.292-.018-4.661-.032C26.469,16.612,26.2,16.765,25.936,16.924Z",
    fill: "#9be9e3",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8427",
    "data-name": "Group 8427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14169",
    "data-name": "Path 14169",
    d: "M20.168,39.518h2.948c.492,0,.664.119.664.412s0,1.4-2.31,1.376C19.19,41.287,19.033,39.518,20.168,39.518Z",
    fill: "#4A4A4A",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8426",
    "data-name": "Group 8426",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14170",
    "data-name": "Path 14170",
    d: "M23.4,40.82a3.2,3.2,0,0,0-1.658-.414,2.178,2.178,0,0,0-1.661.58,2.784,2.784,0,0,0,1.385.32A2.887,2.887,0,0,0,23.4,40.82Z",
    fill: "#f08a1d"
  })))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14171",
    "data-name": "Path 14171",
    d: "M38.825,50.549H20.4L14.93,67.261h3.692L22.411,53.3H38.825Z",
    fill: "#4A4A4A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14172",
    "data-name": "Path 14172",
    d: "M38.825,52.821l-16.731.017L18,67.261h.618L22.411,53.3H38.825Z",
    fill: "#ba4d0b"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14173",
    "data-name": "Path 14173",
    d: "M12.258,59.305H3.634s-1.716-.313-1.782,1.06v5.6s-.067,2.01,1.436,2.112H18.282s.955,0,1.164-1.264l.952-5.71s.007-1.758-1.414-1.83Z",
    fill: "#4A4A4A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14174",
    "data-name": "Path 14174",
    d: "M1.852,62.786v3.183s-.067,2.01,1.436,2.112H18.282s.955,0,1.164-1.264l.676-4.031Z",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8441",
    "data-name": "Group 8441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8433",
    "data-name": "Group 8433"
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14175",
    "data-name": "Path 14175",
    d: "M41.813,63.982A10.013,10.013,0,1,1,31.8,53.967,10.02,10.02,0,0,1,41.813,63.982Z",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8428",
    "data-name": "Group 8428",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14176",
    "data-name": "Path 14176",
    d: "M31.861,55.115a9.7,9.7,0,0,1,9.64,8.561,9.7,9.7,0,0,0-19.407.177,9.868,9.868,0,0,0,.066,1.138c0-.057-.009-.114-.009-.166A9.711,9.711,0,0,1,31.861,55.115Z",
    opacity: 0.5,
    fill: "url(#radial-gradient-5)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8429",
    "data-name": "Group 8429",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14177",
    "data-name": "Path 14177",
    d: "M31.861,72.793a9.7,9.7,0,0,0,9.64-8.562,9.7,9.7,0,0,1-19.407-.168,9.822,9.822,0,0,1,.066-1.142c0,.053-.009.118-.009.164A9.711,9.711,0,0,0,31.861,72.793Z",
    fill: "#1d1d1b",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14178",
    "data-name": "Path 14178",
    d: "M31.8,56.44A7.557,7.557,0,1,0,39.364,64,7.556,7.556,0,0,0,31.8,56.44Z",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14179",
    "data-name": "Path 14179",
    d: "M38.12,63.961a6.4,6.4,0,1,1-6.4-6.4A6.406,6.406,0,0,1,38.12,63.961Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14180",
    "data-name": "Path 14180",
    d: "M37.3,63.961a5.589,5.589,0,1,1-5.583-5.59A5.581,5.581,0,0,1,37.3,63.961Z",
    fill: "#2c2d2b"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14181",
    "data-name": "Path 14181",
    d: "M36.888,63.961a5.173,5.173,0,1,1-5.171-5.171A5.173,5.173,0,0,1,36.888,63.961Z",
    fill: "#686867"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8430",
    "data-name": "Group 8430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14182",
    "data-name": "Path 14182",
    d: "M33.566,63.937A1.764,1.764,0,1,1,31.8,62.175,1.761,1.761,0,0,1,33.566,63.937Z",
    fill: "#2d2e2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8431",
    "data-name": "Group 8431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14183",
    "data-name": "Path 14183",
    d: "M32.794,63.937a.991.991,0,1,1-.992-.992A.994.994,0,0,1,32.794,63.937Z",
    fill: "#2d2e2d",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8432",
    "data-name": "Group 8432",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14184",
    "data-name": "Path 14184",
    d: "M25.446,63.494v.236a6.269,6.269,0,1,0,12.537,0c0-.088-.005-.162-.005-.242A20.225,20.225,0,0,1,25.446,63.494Z",
    fill: "#bbbaba"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8440",
    "data-name": "Group 8440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8436",
    "data-name": "Group 8436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8434",
    "data-name": "Group 8434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14185",
    "data-name": "Path 14185",
    d: "M31.8,59.581a.283.283,0,0,1-.279-.283.28.28,0,0,1,.279-.284.277.277,0,0,1,.277.284A.28.28,0,0,1,31.8,59.581Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14186",
    "data-name": "Path 14186",
    d: "M31.8,68.729a.284.284,0,1,1,.277-.285A.281.281,0,0,1,31.8,68.729Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8435",
    "data-name": "Group 8435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14187",
    "data-name": "Path 14187",
    d: "M36.1,63.87a.282.282,0,0,1,.277-.285.284.284,0,1,1,0,.567A.28.28,0,0,1,36.1,63.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14188",
    "data-name": "Path 14188",
    d: "M26.941,63.87a.292.292,0,0,1,.288-.285.284.284,0,0,1,0,.567A.29.29,0,0,1,26.941,63.87Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8439",
    "data-name": "Group 8439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8437",
    "data-name": "Group 8437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14189",
    "data-name": "Path 14189",
    d: "M34.837,60.836a.281.281,0,0,1,0-.4.293.293,0,0,1,.406,0,.3.3,0,0,1,0,.4A.289.289,0,0,1,34.837,60.836Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14190",
    "data-name": "Path 14190",
    d: "M28.363,67.3a.289.289,0,0,1,0-.4.3.3,0,0,1,.4,0,.284.284,0,0,1-.4.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8438",
    "data-name": "Group 8438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14191",
    "data-name": "Path 14191",
    d: "M34.837,66.9a.3.3,0,0,1,.406,0,.3.3,0,0,1,0,.4.285.285,0,0,1-.406,0A.278.278,0,0,1,34.837,66.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14192",
    "data-name": "Path 14192",
    d: "M28.363,60.436a.285.285,0,1,1,0,.4A.292.292,0,0,1,28.363,60.436Z"
  })))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8444",
    "data-name": "Group 8444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8442",
    "data-name": "Group 8442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14193",
    "data-name": "Path 14193",
    d: "M21.083,17.27h2.525V37.535H9.1c-.088-.045-.166-.09-.239-.134a1.488,1.488,0,0,1-.617-1.185c1.3-4.293,4.236-16.234,4.42-16.992a2.888,2.888,0,0,1,2.712-1.907c.805-.034,2.78-.047,5.7-.047Zm0-.824c-2.494,0-4.806.011-5.739.048a3.7,3.7,0,0,0-3.465,2.516S8.7,31.936,7.409,36.149A2.461,2.461,0,0,0,8.429,38.1a3.769,3.769,0,0,0,.493.256H24.427v-21.9c-1.08-.008-2.227-.008-3.344-.008Z",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8443",
    "data-name": "Group 8443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14194",
    "data-name": "Path 14194",
    d: "M26.808,17.283c2.631.016,4.7.034,4.724.034h.039a4.3,4.3,0,0,1,1.8.435,2.883,2.883,0,0,1,1.578,2.634V37.535H26.808V17.283Zm-.821-.821V38.356H35.77V20.364a4.021,4.021,0,0,0-4.2-3.87h-.029s-2.513-.02-5.555-.032Z",
    fill: "#292929"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8448",
    "data-name": "Group 8448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8445",
    "data-name": "Group 8445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14195",
    "data-name": "Path 14195",
    d: "M6.018,54.152v-4.4a3.353,3.353,0,0,0-2.98-3.329V57.481A3.346,3.346,0,0,0,6.018,54.152Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8446",
    "data-name": "Group 8446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14196",
    "data-name": "Path 14196",
    d: "M5.6,53.847V50.065A2.871,2.871,0,0,0,3.038,47.21v9.5A2.877,2.877,0,0,0,5.6,53.847Z",
    fill: "#ee7125"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8447",
    "data-name": "Group 8447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14197",
    "data-name": "Path 14197",
    d: "M3.038,53.97v2.736A2.884,2.884,0,0,0,5.593,53.97Z",
    fill: "#e63324"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14198",
    "data-name": "Path 14198",
    d: "M3.336,47.981v8.267A25.088,25.088,0,0,0,3.336,47.981Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14199",
    "data-name": "Path 14199",
    d: "M2.287,66.278V60.937s-.048-1.377,1.686-1.356H15.291l-11.318.5s-.956.094-1.14.851Z",
    fill: "#65b339",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14200",
    "data-name": "Path 14200",
    d: "M38.231,46.133H25.407V15.017h-.549V50.549h.549V46.678H38.231Z",
    fill: "#dd8202"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14201",
    "data-name": "Path 14201",
    d: "M18.31,58.79l2.649-7.834,19.094-.163-18.9.648Z",
    fill: "#65b339",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8451",
    "data-name": "Group 8451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14202",
    "data-name": "Path 14202",
    d: "M11.126,19.71c-.347,0-.635-.423-.635-.941s.288-.946.635-.946.631.424.631.946S11.474,19.71,11.126,19.71Z",
    fill: "#c0bac4",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8449",
    "data-name": "Group 8449"
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14203",
    "data-name": "Path 14203",
    d: "M6.556,32.988c0-.569.159-6.9.159-7.947,0-1.349.183-2.1.98-2.117.957-.034,1.319.269,1.319,2.6v7.1c0,.911-.3,1.828-1.163,1.828S6.556,34.33,6.556,32.988Z",
    fill: "#262625"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14204",
    "data-name": "Path 14204",
    d: "M7.851,34.451a1.423,1.423,0,0,1-.953-.218,2.631,2.631,0,0,0,.635.053C8.4,34.286,8.7,33.4,8.7,32.5V25.555c0-2.277-.365-2.568-1.322-2.54a.584.584,0,0,0-.084,0,.835.835,0,0,1,.4-.095c.957-.034,1.319.269,1.319,2.6v7.1C9.014,33.534,8.718,34.451,7.851,34.451Z",
    fill: "#1d1d1b",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8450",
    "data-name": "Group 8450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14205",
    "data-name": "Path 14205",
    d: "M11.534,18.771c0-.437-.228-.793-.505-.793s-.5.356-.5.793.226.791.5.791S11.534,19.208,11.534,18.771Z",
    fill: "url(#radial-gradient-6)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14206",
    "data-name": "Path 14206",
    d: "M11.5,18.771c0-.405-.209-.737-.467-.737s-.462.332-.462.737.2.728.462.728S11.5,19.178,11.5,18.771Z",
    fill: "#262625"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14207",
    "data-name": "Path 14207",
    d: "M10.958,19.287c-.169,0-.314-.207-.314-.466s.145-.461.314-.461.31.2.31.461S11.131,19.287,10.958,19.287Z",
    fill: "#c0bac4",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14208",
    "data-name": "Path 14208",
    d: "M7.312,28.3c-.173,0-.3-.2-.3-.461s.131-.467.3-.467.317.206.317.467S7.485,28.3,7.312,28.3Z",
    fill: "#c0bac4",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14209",
    "data-name": "Path 14209",
    d: "M10.8,18.479H7.377a2.012,2.012,0,0,0-1.5.48,2.229,2.229,0,0,0-.447,1.7v.2c0,.376-.011,1.008-.019,1.734-.014,1.022-.029,2.291-.029,3.368,0,1.746,1.17,2.213,1.787,2.22h0a.357.357,0,0,0,.367-.359.363.363,0,0,0-.358-.366c-.107,0-1.072-.084-1.072-1.5,0-1.077.014-2.337.033-3.354.012-.739.019-1.367.019-1.748v-.2A1.712,1.712,0,0,1,6.4,19.475a1.366,1.366,0,0,1,.979-.267H10.8a.369.369,0,0,0,.362-.375A.358.358,0,0,0,10.8,18.479Z",
    fill: "#2c2d2b"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14210",
    "data-name": "Path 14210",
    d: "M11.051,19.111a.4.4,0,0,1-.25.1H7.377a2.5,2.5,0,0,0-.538.045.862.862,0,0,0-.441.222,1.712,1.712,0,0,0-.232,1.179v.2c0,.381-.007,1.009-.019,1.748-.019,1.017-.033,2.277-.033,3.354,0,1.411.965,1.491,1.072,1.5a.363.363,0,0,1,.358.366.342.342,0,0,1-.085.226H7.447a1.935,1.935,0,0,1-1.79-2.21c0-1.073.019-2.342.037-3.356.01-.724.02-1.349.02-1.724,0-.072,0-.13,0-.193a2.211,2.211,0,0,1,.449-1.7,1.382,1.382,0,0,1,.45-.3,2.825,2.825,0,0,1,.768-.085H10.8a.358.358,0,0,1,.362.354A.416.416,0,0,1,11.051,19.111Z",
    fill: "#686867"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14211",
    "data-name": "Path 14211",
    d: "M11.051,19.111a.4.4,0,0,1-.25.1H7.377a2.5,2.5,0,0,0-.538.045.862.862,0,0,0-.441.222,1.712,1.712,0,0,0-.232,1.179v.2c0,.381-.007,1.009-.019,1.748-.019,1.017-.033,2.277-.033,3.354,0,1.094.573,1.384.886,1.468-.26-.034-1-.248-1-1.49,0-1.072.02-2.335.035-3.36.01-.727.02-1.364.02-1.742v-.206A1.744,1.744,0,0,1,6.28,19.45a.852.852,0,0,1,.451-.214,2.272,2.272,0,0,1,.528-.056h3.434C10.935,19.18,11.116,19.036,11.051,19.111Z",
    fill: "#c0bac4",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14212",
    "data-name": "Path 14212",
    d: "M11.051,19.111a.4.4,0,0,1-.25.1H7.377a2.5,2.5,0,0,0-.538.045,1.832,1.832,0,0,1,.811-.142Z",
    fill: "#c0bac4",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14213",
    "data-name": "Path 14213",
    d: "M11.163,17.619a3.742,3.742,0,0,1,3.385-2.329H35.77l-21.222.26A4.649,4.649,0,0,0,11.163,17.619Z",
    fill: "#fff"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14214",
    "data-name": "Path 14214",
    d: "M42.286,60.249a.757.757,0,0,1-.242-.042.693.693,0,0,1-.391-.891c.036-.081,3.4-8.452,11.447-8.238,7.822.195,9.934,3.821,11.721,8.186a.686.686,0,0,1-.378.89.679.679,0,0,1-.889-.372c-1.658-4.047-3.485-7.161-10.488-7.337a9.694,9.694,0,0,0-7.713,3.568,14.48,14.48,0,0,0-2.422,3.8A.688.688,0,0,1,42.286,60.249Z",
    fill: "#f08b00"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14215",
    "data-name": "Path 14215",
    d: "M42.044,60.207a.693.693,0,0,1-.391-.891c.036-.081,3.4-8.452,11.447-8.238,7.822.195,9.934,3.821,11.721,8.186a.686.686,0,0,1-.378.89c-.351.144-1.376-8.393-11.2-8.254a11.451,11.451,0,0,0-8.323,3.693A26.776,26.776,0,0,0,42.044,60.207Z",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8464",
    "data-name": "Group 8464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8454",
    "data-name": "Group 8454"
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14216",
    "data-name": "Path 14216",
    d: "M143.955,4.4h5.374V17.025h-6.112Z",
    fill: "#686867"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14217",
    "data-name": "Path 14217",
    d: "M146.4,4.4h-2.448l-.739,12.625H146.4Z",
    fill: "#686867",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8453",
    "data-name": "Group 8453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14218",
    "data-name": "Path 14218",
    d: "M149.054,5.372a.437.437,0,1,1-.439-.444A.436.436,0,0,1,149.054,5.372Z",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14219",
    "data-name": "Path 14219",
    d: "M149.054,8.881a.437.437,0,1,1-.439-.436A.437.437,0,0,1,149.054,8.881Z",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14220",
    "data-name": "Path 14220",
    d: "M149.054,12.4a.437.437,0,1,1-.439-.436A.434.434,0,0,1,149.054,12.4Z",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14221",
    "data-name": "Path 14221",
    d: "M149.054,15.913a.437.437,0,1,1-.439-.438A.439.439,0,0,1,149.054,15.913Z",
    fill: "#a1a1a1"
  })))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14222",
    "data-name": "Path 14222",
    d: "M142,19.709V52.217H100.565Z",
    fill: "#686867"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14223",
    "data-name": "Path 14223",
    d: "M136.333,37.923c-.359-1.272-3.347-1.239-3.271-1.325,3-3.3,5.864-6.115,8.934-9.045V19.709L100.565,52.217h36.36C136.9,51.9,136.5,38.511,136.333,37.923Z",
    fill: "#4b4c4b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14224",
    "data-name": "Path 14224",
    d: "M117.455,48.375q4.7-4.8,9.482-9.5c3.171-3.12,13.283-14,15.059-15.735V19.709L100.565,52.217h13.266C115.026,50.917,116.229,49.632,117.455,48.375Z",
    fill: "#4b4c4b",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14225",
    "data-name": "Path 14225",
    d: "M132.706,4.135V.783h11.453V5.393Z",
    fill: "#686867"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8455",
    "data-name": "Group 8455"
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14226",
    "data-name": "Path 14226",
    d: "M88.813,6.183,70.644,13.614a3.717,3.717,0,0,0-2.11,2.014c-.5,1.444-2.562,13.958,0,23.814,0,0,3.675,11.455,9.513,12.458h33.184l33.06-32.459a3.4,3.4,0,0,0,1.35-2.567V5.719s-.4-2.671-2.568-3.226L126,1.021a17.945,17.945,0,0,0-2.566,0c-1.254.1-33.065,4.7-33.065,4.7A16,16,0,0,0,88.813,6.183Z",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14227",
    "data-name": "Path 14227",
    d: "M69.14,14.636a2.792,2.792,0,0,0-.606.992c-.5,1.444-2.562,13.958,0,23.814,0,0,3.675,11.455,9.513,12.458h1.626C71.849,41.437,69.75,27.609,69.14,14.636Z",
    fill: "#4A4A4A",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14228",
    "data-name": "Path 14228",
    d: "M92.239,14.127l35.9-8.319,17.3-.882c-.041-.115-.088-.227-.136-.347H127.566l-35.327,6.6L69.5,20.227a43.713,43.713,0,0,0-2.116,4.139c-.04.7-.069,1.417-.087,2.155a23.156,23.156,0,0,0,2.539-2.958Z",
    fill: "#ffca4c",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14229",
    "data-name": "Path 14229",
    d: "M100.015,36.833,74.683,43.179l-6.149-3.737S72.209,50.9,78.047,51.9h33.184l33.06-32.459a3.4,3.4,0,0,0,1.35-2.567V11.155L133.074,22.037Z",
    fill: "#4A4A4A",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14230",
    "data-name": "Path 14230",
    d: "M104.95,45.573,78.605,50.388l-6.3-3.116S75.66,51.9,78.047,51.9h33.184l33.06-32.459a3.4,3.4,0,0,0,1.35-2.567h0L134.008,28.345Z",
    fill: "#9e7119",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14231",
    "data-name": "Path 14231",
    d: "M69.176,15.364s.434,18.064,7.118,30.961C76.294,46.325,68.262,33.781,69.176,15.364Z",
    fill: "#dd8202"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14232",
    "data-name": "Path 14232",
    d: "M134.247,30.673a.543.543,0,0,1-.536-.488C131.245,7.517,124.17,1.3,124.1,1.24a.557.557,0,0,1-.066-.774A.543.543,0,0,1,124.8.4c.308.254,7.482,6.561,10,29.662a.556.556,0,0,1-.485.608Z",
    fill: "#dd8202"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14233",
    "data-name": "Path 14233",
    d: "M134.247,30.673a.536.536,0,0,1-.536-.488C132.109,5.808,123.84.7,124.03.466A.543.543,0,0,1,124.8.4c.308.254,7.482,6.561,10,29.662a.556.556,0,0,1-.485.608Z",
    fill: "#9e7119",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14234",
    "data-name": "Path 14234",
    d: "M90.97,5.808s6.694,15.214,14.282,40.517C105.252,46.325,94.774,20.549,90.97,5.808Z",
    fill: "#dd8202"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5384",
    "data-name": "Rectangle 5384",
    width: 19.094,
    height: 2.428,
    transform: "translate(129.96 24.804)",
    fill: "#686867"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5385",
    "data-name": "Rectangle 5385",
    width: 19.094,
    height: 1.213,
    transform: "translate(129.96 26.019)",
    fill: "#4b4c4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8456",
    "data-name": "Group 8456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14235",
    "data-name": "Path 14235",
    d: "M147.237,13.125s-19.834,6.5-26.941,9.447-7.975,15.513-10.951,28.134l17.343,1.1s-.594-18.373,3.824-22.562,16.725-11.86,16.725-11.86Z",
    fill: "#9e7119",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14236",
    "data-name": "Path 14236",
    d: "M146.276,13.125s-16.989,6.389-24.107,9.332-9.709,16.733-12.692,29.35h16.248s-.6-18.373,3.824-22.562,16.727-11.86,16.727-11.86Z",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14237",
    "data-name": "Path 14237",
    d: "M113.625,38.2l3.385-8.937a17.545,17.545,0,0,1,6.895-6.847c4.738-2.543,21.525-8.573,21.525-8.573v1.982s-19.579,7.512-21.4,10.7S121.281,38.2,121.281,38.2Z",
    fill: "#ffca4c",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8458",
    "data-name": "Group 8458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8457",
    "data-name": "Group 8457"
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14238",
    "data-name": "Path 14238",
    d: "M147.347.272c-.335,0-.6.185-.6.406V3.339H138.5V.678c0-.221-.27-.406-.6-.406s-.6.185-.6.406V49.03c0,.222.27.4.6.4s.6-.182.6-.4V46.763h8.242V49.03c0,.222.27.4.6.4s.6-.182.6-.4V.678C147.95.457,147.683.272,147.347.272ZM138.5,27.689V22.413h8.242v5.276Zm8.242.81v5.276H138.5V28.5ZM138.5,21.6V16.327h8.242V21.6Zm0-6.09V10.24h8.242v5.274Zm0,19.075h8.242v5.276H138.5Zm8.242-30.441V9.426H138.5V4.148ZM138.5,45.956v-5.28h8.242v5.28Z",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14239",
    "data-name": "Path 14239",
    d: "M147.347.43a.327.327,0,0,0-.218.059.467.467,0,0,0-.18.385c0,.359,0,.88.009,1.547.009,1.332.026,3.234.045,5.519.013,4.564.031,10.649.055,16.739-.024,6.088-.042,12.175-.055,16.743-.038,4.566-.065,7.608-.065,7.608s-.024-3.042-.064-7.608c-.022-4.568-.038-10.655-.06-16.743.022-6.09.038-12.175.06-16.739.016-2.285.032-4.187.043-5.519.009-.667.016-1.188.021-1.547a.476.476,0,0,1,.187-.385A.339.339,0,0,1,147.347.43Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14240",
    "data-name": "Path 14240",
    d: "M137.879.43a.353.353,0,0,0-.215.059.482.482,0,0,0-.182.39c0,.356,0,.882.01,1.546.01,1.328.027,3.23.044,5.515.014,4.566.032,10.653.055,16.739-.023,6.088-.041,12.179-.055,16.743-.037,4.566-.061,7.608-.061,7.608s-.031-3.042-.069-7.608c-.013-4.564-.038-10.655-.058-16.743.02-6.086.045-12.173.058-16.739.019-2.285.033-4.187.05-5.515,0-.664.01-1.19.019-1.546a.467.467,0,0,1,.189-.39A.353.353,0,0,1,137.879.43Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14241",
    "data-name": "Path 14241",
    d: "M138.912,3.512s.46-.029,1.149-.051c.341-.01.745-.028,1.173-.034s.892-.008,1.343-.014.92.006,1.346.014.832.024,1.177.029c.692.027,1.148.056,1.148.056s-.456.036-1.148.059c-.345.009-.742.03-1.177.032s-.883.01-1.346.01-.916,0-1.343-.01-.832-.023-1.173-.032C139.372,3.548,138.912,3.512,138.912,3.512Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14242",
    "data-name": "Path 14242",
    d: "M138.912,9.638s.46-.032,1.149-.053c.341-.009.745-.03,1.173-.034s.892-.01,1.343-.013.92,0,1.346.013.832.025,1.177.031c.692.024,1.148.056,1.148.056s-.456.035-1.148.058c-.345.011-.742.023-1.177.033s-.883.011-1.346.011-.916,0-1.343-.011-.832-.022-1.173-.033C139.372,9.673,138.912,9.638,138.912,9.638Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14243",
    "data-name": "Path 14243",
    d: "M138.912,15.763s.46-.035,1.149-.057c.341-.01.745-.025,1.173-.029s.892-.011,1.343-.015.92,0,1.346.015.832.019,1.177.029c.692.022,1.148.057,1.148.057s-.456.034-1.148.059c-.345.008-.742.023-1.177.032s-.883.009-1.346.009-.916,0-1.343-.009-.832-.024-1.173-.032C139.372,15.8,138.912,15.763,138.912,15.763Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14244",
    "data-name": "Path 14244",
    d: "M138.912,21.889s.46-.036,1.149-.058c.341-.01.745-.027,1.173-.031s.892-.014,1.343-.014.92.005,1.346.011.832.024,1.177.034c.692.022,1.148.058,1.148.058s-.456.035-1.148.055c-.345.012-.742.025-1.177.035s-.883.013-1.346.013-.916-.006-1.343-.018-.832-.018-1.173-.03C139.372,21.924,138.912,21.889,138.912,21.889Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14245",
    "data-name": "Path 14245",
    d: "M138.912,27.945s.46-.034,1.149-.058c.341-.01.745-.023,1.173-.027s.892-.017,1.343-.017.92.006,1.346.012.832.022,1.177.032c.692.024,1.148.058,1.148.058s-.456.034-1.148.057c-.345.012-.742.025-1.177.03s-.883.014-1.346.014-.916,0-1.343-.014-.832-.018-1.173-.03C139.372,27.979,138.912,27.945,138.912,27.945Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14246",
    "data-name": "Path 14246",
    d: "M138.912,34.047s.46-.036,1.149-.058c.341,0,.745-.026,1.173-.032s.892-.006,1.343-.012.92.006,1.346.012.832.027,1.177.032c.692.022,1.148.058,1.148.058s-.456.034-1.148.057c-.345.01-.742.023-1.177.034s-.883.007-1.346.007-.916,0-1.343-.007-.832-.024-1.173-.034C139.372,34.081,138.912,34.047,138.912,34.047Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14247",
    "data-name": "Path 14247",
    d: "M138.912,40.2s.46-.036,1.149-.06c.341-.01.745-.022,1.173-.032s.892-.011,1.343-.011.92,0,1.346.011.832.022,1.177.032c.692.024,1.148.06,1.148.06s-.456.033-1.148.054c-.345.005-.742.025-1.177.034s-.883.006-1.346.01-.916,0-1.343-.01-.832-.029-1.173-.034C139.372,40.23,138.912,40.2,138.912,40.2Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14248",
    "data-name": "Path 14248",
    d: "M138.912,46.184s.46-.035,1.149-.058c.341-.009.745-.028,1.173-.032s.892-.013,1.343-.013.92,0,1.346.013.832.023,1.177.032c.692.023,1.148.058,1.148.058s-.456.028-1.148.059c-.345,0-.742.024-1.177.027s-.883.011-1.346.016-.916-.005-1.343-.016-.832-.024-1.173-.027C139.372,46.212,138.912,46.184,138.912,46.184Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8462",
    "data-name": "Group 8462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14249",
    "data-name": "Path 14249",
    d: "M133.813,51.788a.513.513,0,0,0,.078-.082.074.074,0,0,1,.019-.023,1.359,1.359,0,0,0,.089-.131s0-.007.009-.012c.023-.045.049-.092.074-.146,0-.012.011-.024.016-.036a3.1,3.1,0,0,0,.163-.392.12.12,0,0,1,.016-.04c.019-.064.047-.144.07-.217a.015.015,0,0,1,.009-.012c.022-.088.044-.179.075-.273v-.006c.023-.091.049-.182.068-.279a.051.051,0,0,1,0-.021c.048-.2.092-.418.132-.646v-.018c.041-.225.078-.466.114-.723v-.008a25.527,25.527,0,0,0,.2-3.279,26.367,26.367,0,0,0-.165-2.989v-.006h0c-.245-2.09-.725-3.518-1.295-3.518h-1.62l-.441-1.468c-.132-.673-.654-1.787-1.733-1.787h-8.255c-1.077,0-1.594,1.114-1.732,1.787l-.437,1.468h-1.932v-.143a.6.6,0,0,0-.6-.591.588.588,0,0,0-.589.591v.143h-2.308l-.438-1.468c-.138-.673-.654-1.787-1.739-1.787h-8.252c-1.074,0-1.588,1.114-1.732,1.787l-.435,1.468H99.791c-.557,0-1.049,1.428-1.288,3.518h0v.006a25.031,25.031,0,0,0-.166,2.989,25.537,25.537,0,0,0,.2,3.279l0,.008c.03.257.068.5.108.723a.155.155,0,0,0,0,.018c.044.228.086.445.132.646a.029.029,0,0,0,.006.021c.022.1.041.188.071.279v.006q.033.141.078.273v.012c.027.073.048.153.077.217,0,.015.007.026.007.04.054.145.108.271.164.392.009.012.011.024.02.036a1.325,1.325,0,0,0,.078.146s0,.009.005.012a1.072,1.072,0,0,0,.089.131c0,.01.012.014.022.023a.481.481,0,0,0,.069.082c.008.011.018.014.021.026a.612.612,0,0,0,.093.072s.01,0,.016.007a.343.343,0,0,0,.081.041c.011,0,.013.006.019.009a.377.377,0,0,0,.1.014.5.5,0,0,0,.348-.183v.183h6.519a.577.577,0,0,0,.562.425.588.588,0,0,0,.568-.425h8.389a.582.582,0,0,0,.561.425.594.594,0,0,0,.571-.425h8.542a.592.592,0,0,0,1.136,0h6.5a.3.3,0,0,0,.1-.014.127.127,0,0,1,.03-.009.531.531,0,0,0,.076-.041c.005,0,.011,0,.014-.007a.573.573,0,0,0,.094-.072C133.8,51.8,133.81,51.8,133.813,51.788ZM120.5,37.679l.006-.035c.007-.012.261-1.143.946-1.143H129.7c.674,0,.926,1.131.926,1.143l.383,1.287h-3.994v-.143a.6.6,0,0,0-.6-.591.588.588,0,0,0-.586.591v.143h-5.707Zm-18.024,0,.009-.035c.006-.012.257-1.143.939-1.143h8.252c.677,0,.925,1.131.925,1.143l.384,1.287h-5.166v-.143a.594.594,0,0,0-1.187,0v.143H102.1Z",
    fill: "#323231",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8461",
    "data-name": "Group 8461"
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14250",
    "data-name": "Path 14250",
    d: "M113.684,40.714H100.015l.968-3.251c.147-.673.658-1.787,1.731-1.787h8.255c1.086,0,1.6,1.114,1.739,1.787Zm-12.563-.822h11.458l-.673-2.248c0-.012-.251-1.143-.925-1.143H102.73c-.685,0-.935,1.131-.941,1.143l-.01.035Z",
    fill: "#2e2f2d"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14251",
    "data-name": "Path 14251",
    d: "M119.143,39.892h11.466l-.676-2.248c0-.012-.25-1.143-.922-1.143h-8.26c-.684,0-.938,1.131-.938,1.143l-.01.035Zm12.56.822h-13.66l.969-3.251c.141-.673.658-1.787,1.726-1.787H129c1.075,0,1.6,1.114,1.732,1.787Z",
    fill: "#2e2f2d"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14252",
    "data-name": "Path 14252",
    d: "M132.8,38.931H99.1c-.8,0-1.457,2.914-1.457,6.513s.655,6.513,1.457,6.513a.5.5,0,0,0,.345-.183v.183H132.8c.807,0,1.457-2.917,1.457-6.513S133.6,38.931,132.8,38.931Z",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8460",
    "data-name": "Group 8460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8459",
    "data-name": "Group 8459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14253",
    "data-name": "Path 14253",
    d: "M134.187,43.542c-.027-.381-.06-.748-.1-1.093H97.807c-.04.345-.073.712-.1,1.093Z",
    fill: "#4b4c4b",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14254",
    "data-name": "Path 14254",
    d: "M97.8,48.332c.238,2.148.733,3.625,1.3,3.625a.5.5,0,0,0,.345-.183v.183H132.8c.57,0,1.068-1.477,1.3-3.625Z",
    fill: "#4b4c4b",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14255",
    "data-name": "Path 14255",
    d: "M116.644,51.788a.6.6,0,0,1-.6.594h0a.594.594,0,0,1-.592-.594v-13a.592.592,0,0,1,.592-.591h0a.6.6,0,0,1,.6.591Z",
    fill: "#323231"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14256",
    "data-name": "Path 14256",
    d: "M107.121,51.788a.6.6,0,0,1-.6.594h0a.592.592,0,0,1-.591-.594v-13a.59.59,0,0,1,.591-.591h0a.593.593,0,0,1,.6.591Z",
    fill: "#323231"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14257",
    "data-name": "Path 14257",
    d: "M126.324,51.788a.6.6,0,0,1-.6.594h0a.593.593,0,0,1-.592-.594v-13a.591.591,0,0,1,.592-.591h0a.6.6,0,0,1,.6.591Z",
    fill: "#323231"
  })))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8463",
    "data-name": "Group 8463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14258",
    "data-name": "Path 14258",
    d: "M141.413,30.194a.337.337,0,0,1-.345.335.339.339,0,0,1,0-.678A.34.34,0,0,1,141.413,30.194Z",
    fill: "#4b4c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14259",
    "data-name": "Path 14259",
    d: "M141.413,33.114a.345.345,0,0,1-.345.344.343.343,0,0,1,0-.685A.344.344,0,0,1,141.413,33.114Z",
    fill: "#4b4c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14260",
    "data-name": "Path 14260",
    d: "M141.413,36.046a.344.344,0,0,1-.345.341.343.343,0,0,1,0-.685A.345.345,0,0,1,141.413,36.046Z",
    fill: "#4b4c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14261",
    "data-name": "Path 14261",
    d: "M141.413,38.972a.343.343,0,0,1-.345.341.342.342,0,0,1,0-.684A.344.344,0,0,1,141.413,38.972Z",
    fill: "#4b4c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14262",
    "data-name": "Path 14262",
    d: "M141.413,41.9a.34.34,0,0,1-.345.338.34.34,0,0,1,0-.679A.34.34,0,0,1,141.413,41.9Z",
    fill: "#4b4c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14263",
    "data-name": "Path 14263",
    d: "M141.413,44.823a.344.344,0,0,1-.345.342.343.343,0,0,1,0-.685A.343.343,0,0,1,141.413,44.823Z",
    fill: "#4b4c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14264",
    "data-name": "Path 14264",
    d: "M141.413,47.75a.343.343,0,0,1-.345.341.343.343,0,0,1,0-.685A.344.344,0,0,1,141.413,47.75Z",
    fill: "#4b4c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14265",
    "data-name": "Path 14265",
    d: "M141.413,50.675a.345.345,0,0,1-.345.345.343.343,0,0,1,0-.686A.343.343,0,0,1,141.413,50.675Z",
    fill: "#4b4c4b"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle1);
export default __webpack_public_path__ + "static/media/vehicle-1.3f4aaffd1cbac340d52d4346cf9c0fbe.svg";
export { ForwardRef as ReactComponent };